module.exports = __webpack_public_path__ + "img/trapped_gale_small.ab66e734.png";